import React from 'react';

import styles from './AmountAdjustment.module.css'
import {Icon} from "../../ui/General/Icon/Icon.tsx";

interface Props {
    amount: number
    up: () => void
    down: () => void
    hint?: string
}

export const AmountAdjustment: React.FC<Props> = ({amount, up, down, hint}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.block}>
                <div className={styles.down} onClick={down}>
                    <Icon name='minus' width={16} height={8}/>
                </div>
                <div className={styles.amount}>
                    {amount}
                </div>
                <div className={styles.up} onClick={up}>
                    <Icon name='plus' width={16} height={16}/>
                </div>
            </div>
            {hint && (
                <div className={styles.hint}>
                    {hint}
                </div>
            )}
        </div>
    );
};